













import { defineComponent, type PropType } from "vue-demi";
import { declination } from "@artmizu/utils";

export default defineComponent({
  name: "MPRatingBlock",
  props: {
    rate: {
      type: Number as PropType<number>,
      default: undefined,
    },
    reviewCount: {
      type: Number as PropType<number>,
      default: undefined,
    },
  },
  computed: {
    formattedRate() {
      if (this.rate)
        return Number.isInteger(this.rate) ? this.rate.toFixed(1) : this.rate;
      return null;
    },
    declOfReviewsCount() {
      if (this.reviewCount)
        return `${this.reviewCount} ${declination(this.reviewCount, [
          "оценка",
          "оценки",
          "оценок",
        ])}`;
      return null;
    },
  },
});
